// Loads platform web components dynamically from manifest.json
// Usage: import { loadPlatformWebComponents } from './utils/platformWebComponents';

const ENABLE_STYLES_EVENT = 'platform-ui:enable-platform-wc-styles';
const DISABLE_STYLES_EVENT = 'platform-ui:disable-platform-wc-styles';

const setStylesheetEnabled = (el: HTMLLinkElement, enabled: boolean) => {
  try {
    const stylesheet = Array.from(document.styleSheets).find(
      s => s.href === el.href
    );
    if (enabled) {
      el.removeAttribute('disabled');
      if(stylesheet) stylesheet.disabled = false;
    } else {
      if(stylesheet) stylesheet.disabled = true;
    }
  } catch (error) { }
};

let loadPromise: Promise<void> | null = null;

export function loadPlatformWebComponents() {
  if (!loadPromise) {
    loadPromise = loadBundle();
  }
  return loadPromise;
}

async function loadBundle() {
  try {
    // Fetch manifest to get current file paths
    const response = await fetch(
      `${process.env.NX_PLATFORM_ASSETS_BASE_URL}/platform-wc/manifest.json`
    );
    const manifest = await response.json();

    // Load CSS dynamically
    if (manifest.files && manifest.files.css) {
      const cssLink = document.createElement("link");
      cssLink.rel = "stylesheet";
      cssLink.href = manifest.files.css;
      cssLink.id = "platform-wc-styles";
      cssLink.setAttribute('disabled', 'true'); // Load the CSS but keep it disabled by default
      cssLink.setAttribute('data-html2canvas-ignore', 'true'); // Ignore this file when generating PDFs with html2canvas
      document.head.appendChild(cssLink);
      console.log("CSS loaded:", cssLink.href);

      addEventListener(ENABLE_STYLES_EVENT, e => setStylesheetEnabled(cssLink, true));
      addEventListener(DISABLE_STYLES_EVENT, e => setStylesheetEnabled(cssLink, false));
    }

    // Load JS module dynamically
    if (manifest.files && manifest.files.es) {
      const script = document.createElement("script");
      script.type = "module";
      script.src = manifest.files.es;
      document.body.appendChild(script);
      console.log("JS loaded:", script.src);
    }
  } catch (error) {
    console.error("Failed to load manifest or web components:", error);
  }
}
